export default __webpack_public_path__ + "static/media/mail1.863ba276.svg";